import React from 'react';

import { FormControl, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Select from '../../../../components/forms/Select';
import { UserRole } from '../../constants/user-roles';

const StyledFormControl = styled(FormControl)`
    margin-left: 1rem;
    width: 200px;
`;

export interface UserRoleFilterProps {
    onRoleChange: (role: UserRole) => void;
}

const UserRoleFilter: React.FC<UserRoleFilterProps> = ({ onRoleChange }) => {
    const { t } = useTranslation('admin_settings');

    const handleRoleChange = (event) => {
        onRoleChange(event.target.value);
    };

    return (
        <StyledFormControl>
            <Select name="role" label={t('users.role-filter')} onChange={handleRoleChange}>
                <MenuItem value="" selected>
                    {t('users.role-filter-none')}
                </MenuItem>
                <MenuItem value={UserRole.Admin}>{t('users.userRoles.admin')}</MenuItem>
                <MenuItem value={UserRole.Teacher}>{t('users.userRoles.teacher')}</MenuItem>
                <MenuItem value={UserRole.InstructionalDesigner}>
                    {t('users.userRoles.instructional-designer')}
                </MenuItem>
            </Select>
        </StyledFormControl>
    );
};

export default UserRoleFilter;
